import { render } from "./ArticleDisplay.vue?vue&type=template&id=53824c76&scoped=true"
import script from "./ArticleDisplay.vue?vue&type=script&lang=js"
export * from "./ArticleDisplay.vue?vue&type=script&lang=js"

import "./ArticleDisplay.vue?vue&type=style&index=0&id=53824c76&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53824c76"]])

export default __exports__